import fs from 'fs';
import os from 'os';
import path from 'path';

import { error, hint } from './output.ts';

const CREDENTIALS_PATH = path.join(os.homedir(), '.sortlist', 'credentials.json');

export interface Credentials {
  accessToken: string;
  refreshToken: string;
  idToken: string;
  expiresAt: number;
}

function ensureDir(): void {
  const dir = path.dirname(CREDENTIALS_PATH);
  if (!fs.existsSync(dir)) {
    fs.mkdirSync(dir, { recursive: true });
  }
}

export function saveCredentials(creds: Credentials): void {
  ensureDir();
  fs.writeFileSync(CREDENTIALS_PATH, JSON.stringify(creds, null, 2) + '\n', { mode: 0o600 });
}

export function loadCredentials(): Credentials | null {
  try {
    const raw = fs.readFileSync(CREDENTIALS_PATH, 'utf-8');
    return JSON.parse(raw) as Credentials;
  } catch {
    return null;
  }
}

export function clearCredentials(): void {
  try {
    fs.unlinkSync(CREDENTIALS_PATH);
  } catch {
    // already gone
  }
}

export function isExpired(creds: Credentials): boolean {
  // 60s buffer before actual expiry
  return Date.now() >= (creds.expiresAt - 60) * 1000;
}

export function ensureAuthenticated(): Credentials {
  const creds = loadCredentials();
  if (!creds) {
    error('You are not logged in.');
    hint('Run `sl login` to authenticate with your Sortlist account.');
    process.exit(2);
  }
  return creds;
}
